
import React, { useEffect } from 'react';
import { HOME_TITLE, HOME_DESCRIPTION, HOME_STRUCTURED_DATA } from '@/data/homeSeo';
import { SITE_URL } from '@/data/blogSeoMetadata';
import {
  OG_HOME_IMAGE_ALT,
  OG_HOME_IMAGE_URL,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_TYPE,
  OG_IMAGE_WIDTH,
} from '@/data/socialSeo';
import { detachPageSeo } from '@/utils/pageSeo';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import LandingPageContent from '@/components/landing/LandingPageContent';

const Index: React.FC = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const restorePageSeo = detachPageSeo();
    document.title = HOME_TITLE;
    const tags: HTMLElement[] = [];
    for (const [attribute, key, content] of [
      ['name', 'description', HOME_DESCRIPTION],
      ['property', 'og:title', HOME_TITLE],
      ['property', 'og:description', HOME_DESCRIPTION],
      ['property', 'og:url', `${SITE_URL}/`],
      ['property', 'og:type', 'website'],
      ['property', 'og:image', OG_HOME_IMAGE_URL],
      ['property', 'og:image:type', OG_IMAGE_TYPE],
      ['property', 'og:image:width', String(OG_IMAGE_WIDTH)],
      ['property', 'og:image:height', String(OG_IMAGE_HEIGHT)],
      ['property', 'og:image:alt', OG_HOME_IMAGE_ALT],
      ['name', 'twitter:card', 'summary_large_image'],
      ['name', 'twitter:title', HOME_TITLE],
      ['name', 'twitter:description', HOME_DESCRIPTION],
      ['name', 'twitter:image', OG_HOME_IMAGE_URL],
      ['name', 'twitter:image:alt', OG_HOME_IMAGE_ALT],
    ]) {
      const tag = document.createElement('meta');
      tag.setAttribute(attribute, key);
      tag.content = content;
      tags.push(tag);
    }
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${SITE_URL}/`;
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify(HOME_STRUCTURED_DATA);
    tags.push(canonical, schema);
    tags.forEach(tag => document.head.appendChild(tag));
    return () => {
      tags.forEach(tag => tag.remove());
      restorePageSeo();
      document.title = previousTitle;
    };
  }, []);

  return (
    <div id="top" className="min-h-screen flex flex-col">
      <Navbar />
      <LandingPageContent />
      <Footer />
    </div>
  );
};

export default Index;
